var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AdminAppBar'),_c('v-container',{staticClass:"text-center",attrs:{"fluid":""}},[_c('Appointments'),_c('Scheduler',{attrs:{"admin":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }